import * as type from './constant';

const initialState = {
  dataMember: [],
  dataMemberOverview: null,

  updatedMember: null,
  addedMember: null,
  deletedMember: null,
  updatedMemberSelf: null,

  loading: false,
  loadingManipulation: false,
  error: null,
  errorManipulation: null,
};
export default (state = initialState, action) => {

  switch (action.type) {

    case type.GET:
      return {
        ...state,
        updatedMember: null,
        addedMember: null,
        deletedMember: null,
        loading: true,
        loadingManipulation: false,
        error: null,
        errorManipulation: null,
      };

    case type.GET_SUCCESS:
      return {
        ...state,
        [`dataMember${action.selfRole}`]: [...action.payload],
        loading: false,
      };

    case type.GET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case type.ADD:
      return {
        ...state,
        addedMember: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.ADD_SUCCESS:
      return {
        ...state,
        addedMember: action.payload,
        loadingManipulation: false,
      };

    case type.UPDATE:
      return {
        ...state,
        updatedMember: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.UPDATE_SUCCESS:
      return {
        ...state,
        updatedMember: action.payload,
        loadingManipulation: false,
      };

    case type.DELETE:
      return {
        ...state,
        deletedMember: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.DELETE_SUCCESS:
      return {
        ...state,
        deletedMember: action.payload,
        loadingManipulation: false,
      };

    case type.UPDATE_SELF:
      return {
        ...state,
        updatedMemberSelf: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.UPDATE_SELF_SUCCESS:
      return {
        ...state,
        updatedMemberSelf: action.payload,
        loadingManipulation: false,
      };

    case type.MANIPULATION_ERROR:
      return {
        ...state,
        loadingManipulation: false,
        errorManipulation: action.error,
      };

    case type.GET_OVERVIEW:
      return {
        ...state,
        loadingManipulation: false,
        errorManipulation: null,
      };

    case type.GET_OVERVIEW_SUCCESS:
      return {
        ...state,
        dataMemberOverview: {...action.payload},
        loadingManipulation: false,
      };

    default:
      return state;
  }
};
